
<div
    v-if="isClient()"
    v-tooltip="{ content: $t('general.teammember') }"
    class="colleague-icon"
>
    <svg-icon icon="colleague" />
</div>
